import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import TextField from "../../../Components/TextField";
import Button from "../../../Components/Button";
import { Typography } from "../../../Components/Typography";
import { forgetPassword } from "../../../Utils/apiServices";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    setSubmitting(true);

    // Basic email validation
    if (!email.trim()) {
      setError("Email is required");
      setSubmitting(false);
      return;
    }

    if (!email.includes("@")) {
      setError("Please enter a valid email address");
      setSubmitting(false);
      return;
    }

    try {
      const response = await forgetPassword({ email });
      if (response.success) {
        setSuccess(true);
        // Reset form after 3 seconds and redirect to login
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      }
    } catch (err) {
      setError(err.error || "Failed to send reset link. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-primary flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-lg bg-white shadow-lg rounded-2xl border border-slate-200 p-8 flex flex-col gap-6">
        <div className="flex flex-col items-center gap-4 text-center">
          <div>
            <img src="/ign-logo.svg" alt="IgniteNext Logo" className="h-15 w-50" />
          </div>
          <div>
            <Typography as="h1" className="text-2xl font-bold text-primary-900">
              Reset Password
            </Typography>
            <Typography as="p" className="text-sm text-tertiary-600 mt-1">
              Enter your email to receive a password reset link.
            </Typography>
          </div>
        </div>

        {success ? (
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2 rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-600">
              <Icon icon="lucide:check-circle" className="h-4 w-4" />
              <span>
                Password reset link has been sent to your email. Redirecting to login...
              </span>
            </div>
          </div>
        ) : (
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <TextField
              label="Email"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              autoFocus
            />

            {error && (
              <div className="flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-600">
                <Icon icon="lucide:alert-circle" className="h-4 w-4" />
                <span>{error}</span>
              </div>
            )}

            <Button type="submit" fullWidth disabled={submitting}>
              {submitting ? "Sending..." : "Send Reset Link"}
            </Button>
          </form>
        )}

        <div className="flex items-center justify-center text-sm text-tertiary-600">
          <span>
            Remember your password?{" "}
            <Link to="/login" className="text-brand-blue hover:underline">
              Sign in
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

